export interface ParameterInfo {
  min: number;
  max: number;
  step: number;
  units: Units | null;
  serialize: (value: number) => number;
  deserialize: (value: number) => number;
  classifyAble: boolean;
}

export const enum Units {
  Pixels = "px",
  Count = "pcs",
  Degrees = "°",
}
